module.exports = __webpack_public_path__ + "static/media/birth-cert-step1.4e7e0380.png";